(function () {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                },
                'footer@': {
                    templateUrl: 'app/layouts/footer/footer.html'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }],
                availableDates: ['YieldCurveResultsOpen', function (YieldCurveResultsOpen) {
                    return YieldCurveResultsOpen.query({datesOnly: ""}, function (res) {
                        return res.sort();
                    }).$promise;
                }],
                availableDatesCorpAaa: ['CorporateCurveResultsOpen', function (CorporateCurveResultsOpen) {
                    return CorporateCurveResultsOpen.query({datesOnly: "", rating: "aaa"}, function (res) {
                        return res.sort();
                    }).$promise;
                }],
                availableDatesCorpBb: ['CorporateCurveResultsOpen', function (CorporateCurveResultsOpen) {
                    return CorporateCurveResultsOpen.query({datesOnly: "", rating: "bb"}, function (res) {
                        return res.sort();
                    }).$promise;
                }]
            }
        });
    }
})();
